import $api from "@/api/index";
import type { ApiPagination } from "@/utils/types";
import type { SkyStarI } from "@/types/sky";
import type { SkyPlacement } from "@/store/firefliesNight";

export async function getSkyStars(): Promise<SkyStarI[]> {
  const res = await $api.get<ApiPagination<SkyStarI> | SkyStarI[]>(
    "/sky/stars/"
  );

  return Array.isArray(res.data) ? res.data : res.data.results;
}

export async function patchSkyStar(
  id: string,
  data: Partial<Pick<SkyStarI, "x" | "y" | "public" | "color">>
): Promise<SkyStarI> {
  const res = await $api.patch<SkyStarI>(`/sky/stars/${id}/`, data);

  return res.data;
}

export async function createSkyStar(
  petId: string,
  skyPlacement: SkyPlacement
): Promise<SkyStarI> {
  const res = await $api.post<SkyStarI>("/sky/stars/", {
    pet_id: petId,
    sky_placement: skyPlacement,
  });

  return res.data;
}

export async function deleteSkyStar(id: string): Promise<void> {
  await $api.delete(`/sky/stars/${id}/`);
}
